
/**
 * Module dependencies.
 */

import { categoriesValues } from './categories';

/**
 * Export `availableFiltersKeys`.
 */

export const availableFiltersKeys = {
  category: 'category',
  collection: 'collection_id',
  location: 'country_alpha2'
} as const;

/**
 * Export `availableFiltersValues`.
 */

export const availableFiltersValues = {
  [availableFiltersKeys.category]: Object.values(categoriesValues)
};
